import script from "./TextboxMixin.vue?vue&type=script&lang=ts"
export * from "./TextboxMixin.vue?vue&type=script&lang=ts"

export default script